<template lang="pug">
Fragment
  b-form-group
    label.samtek-label(for="input-modelos") Modelo
    .d-flex.gap-3.flex-column.flex-sm-row.align-items-center
      vue-typeahead-bootstrap.w-100(
        v-model="model"
        :data="modelsOptions"
        :serializer="s => s.text"
        @hit="handleHit"
        @input="handleSearch"
        :placeholder="showModel"
        :disabled="disabled"
        :input-class="state === false ? 'is-invalid' : (state ? 'is-valid' : null)"
        :minMatchingChars="0"
      )
      slot( name="invalid-feedback")
      button.samtek-btn-secondary(
        type="button"
        @click="showCreateModal = true, createForm = { years_warranty: 1 }" :disabled="disabled"
      ) Nuevo Modelo
  //- Modal Crear Marca
  b-modal.create-modal-brand(
    v-model="showCreateModal"
    :title="showCreateModalBrand ? 'Agregar marca' : 'Crear Equipo'"
    :hide-footer="showCreateModalBrand"
    ok-title="Crear"
    :disabled="loading"
    @ok="onSubmit"
  )
    b-form(v-show="showCreateModalBrand")
      b-row
        b-col
          b-form-group(
            id="input-group-newbramd"
            label="Marca"
            label-for="input-new-brand"
          )
            b-form-input(
              id="input-new-brand"
              v-model="newBrand"
              @input="$v.newBrand.$touch()"
              :state="$v.newBrand.$dirty ? !$v.newBrand.$invalid : null"
            )
            .errors(v-if="$v.newBrand.$dirty")
              b-form-invalid-feedback(:state="$v.newBrand.required")
                | Campo requerido
      b-row
        b-col.d-flex.flex-row
          b-button.ml-auto(@click="onSubmitNewBrand" :disabled="loading") Agregar Marca
    b-form(v-show="!showCreateModalBrand")
      b-row
        b-col
          b-form-group(
            id="input-group-equipmentType"
            label="Tipo de Equipo"
            label-for="input-equipmentType"
          )
            b-form-select(
              id="input-equipmentType"
              :options="tiposAsOptions"
              v-model="createForm.tipo_dispositivo"
              @input="$v.createForm.tipo_dispositivo.$touch()"
              :state="$v.createForm.tipo_dispositivo.$dirty ? !$v.createForm.tipo_dispositivo.$invalid : null"
            )
              template( #item="{ item }" )
            .errors(v-if="$v.createForm.tipo_dispositivo.$dirty")
              b-form-invalid-feedback(:state="$v.createForm.tipo_dispositivo.required")
                | Campo requerido
      b-row
        b-col
          b-form-group(
            id="input-group-part_number"
            label="Part Number"
            label-for="input-part_number"
          )
            b-form-input(
              id="input-part_number"
              v-model="createForm.part_number"
              placeholder="Ingrese número de parte..."
              @input="$v.createForm.part_number.$touch()"
              :state="$v.createForm.part_number.$dirty ? !$v.createForm.part_number.$invalid : null"
            )
            .errors(v-if="$v.createForm.part_number.$dirty")
              b-form-invalid-feedback(:state="$v.createForm.part_number.required")
                | Campo requerido
        b-col
          b-form-group(
            id="input-group-model"
            label="Años de garantía"
            label-for="input-brand"
          )
            b-form-select(
              id="input-brand"
              v-model="createForm.years_warranty"
              :options="yearsOptions"
            )
      b-row
        b-col
          b-form-group(
            id="input-group-model"
            label="Marca"
            label-for="input-brand"
          )
            b-form-select(
              id="input-brand"
              v-model="createForm.marca"
              :options="brandOptions"
              :state="$v.createForm.marca.$dirty ? !$v.createForm.marca.$invalid : null"
              @change="handleBrandChange"
            )
            .errors(v-if="$v.createForm.marca.$dirty")
              b-form-invalid-feedback(:state="$v.createForm.marca.required")
                | Campo requerido
        b-col
          b-form-group(
            id="input-group-model"
            label="Nombre Modelo"
            label-for="input-model"
          )
            b-form-input(
              id="input-model"
              v-model="createForm.model_name"
              :state="$v.createForm.model_name.$dirty ? !$v.createForm.model_name.$invalid : null"
              @input="$v.createForm.model_name.$touch()"
            )
            .errors(v-if="$v.createForm.model_name.$dirty")
              b-form-invalid-feedback(:state="$v.createForm.model_name.required")
                | Campo requerido
    template(#modal-footer="{ ok, cancel}")
      b-button.secondary-btn(@click="cancel" variant="outline") Cancelar
      b-button.primary-btn(@click="ok" variant="samtek-yellow") Crear
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators/'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'

export default {
  components: {
    VueTypeaheadBootstrap,
  },
  name: 'Modelos',
  props: ['modelo_id', 'disabled', 'inputName', 'state'],
  validations: {
    createForm: {
      marca: { required },
      tipo_dispositivo: { required },
      model_name: { required },
      part_number: { required },
    },
    newBrand: { required },
  },
  data() {
    return {
      selected_model: this.modelo_id,
      showCreateModal: false,
      showCreateModalBrand: false,
      createForm: {
        marca: null,
        tipo_dispositivo: null,
        model_name: null,
        part_number: null,
        years_warranty: 1,
      },
      yearsOptions: [1, 2, 3, 4, 5],
      newBrand: null,
      model: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('EquipmentStore', ['models', 'brands', 'equipment']),
    ...mapGetters('TipoDispositivoStore', ['tiposAsOptions', 'tipos']),
    modelsOptions() {
      return this.models.map((val) => {
        const tipoNombre = val.tipo_dispositivo
          ? val.tipo_dispositivo.nombre
          : '-'
        const { model_name, part_number } = val
        return {
          value: val.id,
          text: `${tipoNombre} - ${model_name} - ${part_number}`,
        }
      })
    },
    brandOptions() {
      return this.brands
        .map((val) => ({ value: val.id, text: val.marca_name }))
        .concat([
          {
            value: 'nuevo',
            text: 'Crear...',
          },
        ])
    },
    showModel() {
      if (!this.equipment) return 'Escriba nombre del modelo...'
      return this.equipment.modelo_detail
        ? `${
            this.equipment.modelo_detail.tipo_dispositivo
              ? this.equipment.modelo_detail.tipo_dispositivo.nombre
              : ''
          } - ${this.equipment.modelo_detail.model_name}`
        : 'Escriba nombre del modelo...'
    },
  },
  methods: {
    ...mapActions('EquipmentStore', [
      'getModels',
      'getBrands',
      'createModel',
      'createBrand',
    ]),
    ...mapActions('TipoDispositivoStore', ['fetchTipos']),
    handleHit(event) {
      this.$emit('dataModel', event)
      this.selected_model = event.value
      const value = event.value // eslint-disable-line
      if (value === 'nuevo') {
        this.showCreateModal = true
        this.createForm = { years_warranty: 1 }
      } else {
        this.selected_model = value
        this.$emit('onModelSelect', value)
      }
    },
    async fetchModels(query = '') {
      this.selected_model = this.modelo_id
      this.getBrands()
      await this.getModels(query)
    },
    handleSearch(query) {
      // Server-side search when user types in the model field
      this.getModels(query)
    },
    handleModelChange(modelId) {
      if (modelId === 'nuevo') {
        this.showCreateModal = true
        this.createForm = { years_warranty: 1 }
      } else {
        console.log('emiting onModelSelect', modelId)
        this.selected_model = modelId
        this.$emit('onModelSelect', modelId)
      }
    },
    async onSubmit() {
      if (this.$v.createForm.$invalid) {
        this.$bvToast.toast('Rellene todos los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else {
        this.loading = true
        const action = this.createModel
        try {
          const res = await action(this.createForm)
          this.loading = false
          this.$bvToast.toast('Modelo guardado exitosamente', {
            variant: 'success',
          })
          await this.getModels()
          const { tipo_dispositivo, model_name, part_number, id } =
            res.data.Modelo
          const typeText = tipo_dispositivo ? tipo_dispositivo.nombre : '-'
          this.model = `${typeText} - ${model_name} - ${part_number}`
          this.selected_model = id
          this.$emit('onModelSelect', id)
        } catch (err) {
          this.$bvToast.toast(`Error al guardar: ${err}`, {
            variant: 'danger',
          })
        }
      }
    },
    async onSubmitNewBrand() {
      this.loading = true
      if (this.$v.newBrand.$invalid) {
        this.$bvToast.toast('Rellene todos los campos requeridos', {
          variant: 'danger',
        })
      } else {
        const res = await this.createBrand({
          marca_name: this.newBrand,
        })
        this.createForm.marca = res.data.id
        await this.getBrands()
        this.showCreateModalBrand = false
      }
      this.loading = false
    },
    handleBrandChange() {
      this.$v.createForm.marca.$touch()
      if (this.createForm.marca === 'nuevo') {
        this.showCreateModalBrand = true
        this.newBrand = ''
      }
    },
  },
  created() {
    this.fetchModels()
    this.fetchTipos()
  },
  watch: {
    equipment() {
      this.fetchModels()
    },
    modelo_id() {
      this.selected_model = this.modelo_id
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/style/colors.scss';
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.samtek-label {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #23201c;
  display: block;
  margin-bottom: 8px;
}

.samtek-btn-secondary {
  min-width: 130px;
  flex-shrink: 0;
  height: 45px;
  padding: 10px 20px;
  background-color: #f5f6fa;
  color: #23201c;
  border: 1px solid #525252;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s;

  &:hover {
    background-color: #e8e9ef;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @include media-breakpoint-down(sm) {
    width: 100%;
  }
}

.form-group::v-deep label {
  color: $samtek-grey;

  &.active-label {
    color: $samtek-black;
  }
}
</style>
